module.exports = __webpack_public_path__ + "static/media/MRRTCB.crop.95ee2fdd.jpg";